module.exports = __webpack_public_path__ + "img/3.1e0bb527.png";